if (!customElements.get('discount-popup')) {
  customElements.define('discount-popup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.closeButton = this.querySelector('[data-discount-popup-close]');
      this.closeButton?.addEventListener('click', () => this.dismiss());
      this.dialog?.addEventListener('cancel', () => this.rememberDismissal());

      const posted = this.querySelector('[data-discount-popup-posted]')?.dataset.discountPopupPosted === 'true';
      if (posted) {
        localStorage.setItem('kofea:discount-popup', 'subscribed');
        this.open();
        return;
      }

      if (localStorage.getItem('kofea:discount-popup')) return;
      const delay = Number.parseInt(this.dataset.delay, 10) || 15000;
      this.timeoutId = window.setTimeout(() => this.open(), delay);
    }

    open() {
      // Wait while Shopify's cookie banner is on screen, so the two never stack.
      if (document.getElementById('shopify-pc__banner')?.checkVisibility?.()) {
        this.timeoutId = window.setTimeout(() => this.open(), 3000);
        return;
      }
      if (this.dialog && !this.dialog.open) this.dialog.showModal();
    }

    rememberDismissal() {
      localStorage.setItem('kofea:discount-popup', 'dismissed');
    }

    dismiss() {
      window.clearTimeout(this.timeoutId);
      this.rememberDismissal();
      this.dialog?.close();
    }
  });
}
